<template>
  <div class="options-menu-section" role="group" :aria-label="title || undefined">
    <h6 v-if="title" class="options-menu-section__title">{{ title }}</h6>
    <div class="options-menu-section__grid">
      <slot></slot>
    </div>
  </div>
</template>

<script setup>
// One section of an OptionsMenuModal: a short title, then its tiles two to a row — an odd
// last tile sits alone at half width, as in the apps (OptionsSheetSection / OptionsSheetGrid).
// A div, not a <section>: app.scss gives every section a 4rem !important bottom margin.
defineProps({
  title: { type: String, default: '' },
});
</script>

<style scoped>
.options-menu-section {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

/* The apps' section title (OptionsSheetSectionTitle): bold, muted, upper case. */
.options-menu-section__title {
  margin: 0;
  color: #b2b2b2;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
}

.options-menu-section__grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 8px;
}
</style>
